'use client'

import { referencesProductArticleDetailShownAtom } from '@/feature/product/services/referencesProduct.store'
import { useAtomValue } from 'jotai'
import type { ReferencesProductRowDesktopDetailsProps } from './ReferencesProductRowDesktopDetails.client'
import { ReferencesProductRowDesktopDetails } from './ReferencesProductRowDesktopDetails.client'

export function ReferencesProductRowDesktopDetailsWrapper(
  props: ReferencesProductRowDesktopDetailsProps,
) {
  const referencesProductArticleDetailShown = useAtomValue(referencesProductArticleDetailShownAtom)
  const areDetailsShown = referencesProductArticleDetailShown === props.article.reference

  if (!areDetailsShown) {
    return null
  }

  return (
    <tr className="border-b-px border-b-brand-2-200 align-top desktop:table-row">
      <ReferencesProductRowDesktopDetails {...props} />
    </tr>
  )
}
